import { routes } from "@/router/Routes";
import { interactionStore } from "@/stores/Stores";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

const NavigationHandler = observer(() => {
  const navigate = useNavigate();
  const url = interactionStore.navigate;

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!url) return;

    if (url[0] === "/") {
      // local redirect - no need to pass tokens as params
      if (navigate) {
        navigate(url);
      } else {
        // Fallback if navigate function is not available
        window.location.href = url;
      }
    } else if (url.slice(0, 4) === "http") {
      // external redirect - no need to pass tokens in URL
      window.location.href = url;
      interactionStore.xdomain = "localhost";
    } else {
      console.error("InteractionStore.redirect(): Invalid redirect URL");
      // Fallback to profile page if redirect URL is invalid
      if (navigate) {
        navigate(routes.pages.profile);
      } else {
        window.location.href = routes.pages.profile;
      }
    }
  }, [url]);

  return null;
});

export default NavigationHandler;
